const withAddress = address => prevProject => ({
    ...prevProject,
    address,
});

export default withAddress;
